import React from 'react';
import {useNavigate} from 'react-router-dom';
import AppAnimateGroup from '../../../@crema/core/AppAnimateGroup';
import {Button} from 'antd';
import '../index.style.less';
import AppPageMetadata from '../../../@crema/core/AppPageMetadata';
import {ReactComponent as Logo} from '../../../assets/icon/403.svg';
import {useTranslation} from 'react-i18next';

const Error403 = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const onGoBackToHome = () => {
    navigate(-1);
  };

  return (
    <AppAnimateGroup type='bottom'>
      <AppPageMetadata title='Unauthorized' />
      <div className='error-container' key='a'>
        <div className='error-img'>
          <Logo />
        </div>
        <div className='error-content'>
          <h3>Unauthorized</h3>
          <div className='error-para'>
            <p className='mb-0'>You are not authorized for this page!</p>
          </div>
          <Button type='primary' className='error-btn' onClick={onGoBackToHome}>
            <h5>{t('int-error-go-back-to-home')}</h5>
          </Button>
        </div>
      </div>
    </AppAnimateGroup>
  );
};

export default Error403;
